import SessionsRegistration from './SessionsRegistration';

export default SessionsRegistration;
